'use strict';

angular.module('atex.dam').directive('damIcon',['DamPartitionsService', function(DamPartitionsService) {
  return {
    restrict : 'E',
    scope : {
      type : "="
    },
    link : function(scope, element, attrs) {
      var partition = (attrs.partition) ? attrs.partition :  "true";

      var iconHtml = "";
      if (attrs.objtype !== undefined && attrs.objtype === "'image'") {
        iconHtml = "<i class=\"fa fa-camera\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'page'") {
        iconHtml = "<i class=\"fa fa-file\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'article'") {
        iconHtml = "<i class=\"fa fa-pencil\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'video'") {
        iconHtml = "<i class=\"fa fa-video-camera\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'audio'") {
        iconHtml = "<i class=\"fa fa-volume-up\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'collection'") {
        iconHtml = "<i class=\"fa fa-folder\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'tweet'") {
        iconHtml = "<i class=\"fa fa-twitter\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'instagram'") {
        iconHtml = "<i class=\"fa fa-instagram\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'job'") {
        iconHtml = "<i class=\"fa fa-tasks\"></i>";
      } else if (attrs.objtype !== undefined && attrs.objtype === "'graphic'") {
        iconHtml = "<i class=\"fa fa-bar-chart\"></i>";
      }

      if(partition === "true") {
        var partitions = DamPartitionsService.getPartitions();
        var obj = partitions[attrs.inputtemplate];
      
        if(attrs.metadata) {
          var metadata = JSON.parse(attrs.metadata);
      
          if( metadata ) {
            var dimensions = atex.onecms.ObjectUtils.getByPath(metadata, 'data/metadata/dimensions')||[];
            var dimension = _.find(dimensions, function(dim) {
    	      return dim.id === 'dimension.partition';
    	    });
    	
            if (dimension) {
              partitions = DamPartitionsService.getTemplates();
              if (dimension.entities.length>0) {
                obj = partitions[dimension.entities[0].id];
              }
            }
          }
        }

        if(!obj) {
          iconHtml = "<i class='fa fa-archive'></i>&nbsp;" + iconHtml;
        } else {
    	  iconHtml = "<i style='color:"+obj.color+"' class='" + obj.icon + "'></i>&nbsp;" + iconHtml;
        }
      }

      element.prepend(iconHtml);
      setTimeout(function() {
        scope.$destroy();
      }, 0);
    }
  };
}]);
